import React from "react"

import VenueFooter from "@/components/public/venue/venue_footer"
import VenueImageGallery from "@/components/public/venue/venue_image_gallery"
import PublicTopBar from "@/pages/public/top_bar"

import BookingFlow from "./booking_flow"
import type { ModalState, ModalAction, VenueType } from "./types"
import VenueContent from "./venue_content"
import VenueDetailsColumn from "./venue_details_column"

const STYLES = {
  container: "min-h-screen bg-white",
  content: "max-w-[960px] mx-auto pb-24 md:pb-0 flex flex-col gap-5",
  grid: "grid grid-cols-1 gap-0 md:grid-cols-3 md:gap-8 lg:mx-auto lg:w-fit lg:grid-cols-[650px_300px] lg:gap-[10px]",
  mainColumn: "min-w-0 md:col-span-2 lg:col-span-1",
  sidebarColumn: "hidden md:block md:col-span-1",
} as const

type Props = {
  venue: VenueType
  venueLogoUrl: string | null
  modalState: ModalState
  dispatch: React.Dispatch<ModalAction>
}

const Desktop: React.FC<Props> = ({ venue, venueLogoUrl, modalState, dispatch }) => (
  <div className={STYLES.container} data-testid="public-venue-container">
    <PublicTopBar />

    <div className={STYLES.content} data-testid="public-venue-content">
      <VenueImageGallery images={venue.images || []} />

      <div className={STYLES.grid}>
        <div className={STYLES.mainColumn}>
          <VenueContent venue={venue} />
        </div>

        <div className={STYLES.sidebarColumn} data-testid="public-venue-sidebar-column">
          <VenueDetailsColumn venue={venue} onOpenBooking={() => dispatch({ type: "OPEN_BOOKING" })} />
        </div>
      </div>
    </div>

    <VenueFooter />

    <BookingFlow venue={venue} venueLogoUrl={venueLogoUrl} modalState={modalState} dispatch={dispatch} />
  </div>
)

export default Desktop
